import { createApp } from "vue";
import App from "./App.vue";
import store from "./store";
import SweetModal from "thomson-sweet-modal-vue/src/plugin.js"
import i18n from "./i18n"
import VueGtag from "vue-gtag"
import axios from "axios"

const app = createApp(App);

app.config.productionTip = false;
// Set up error handler to send logs to TIM db
app.config.errorHandler = function (error, instance, info) {

  let payload = {
    source: "Widget.SpecialMachining.Shafting",
    systemIp: null,
    systemPort: window.location.port,
    urlPath: window.location.href,
    clientIp: null,
    referer: document.referrer,
    httpStatusCode: null,
    requestTimeSeconds: null,
    uniqueId: null,
    description: error.message,
    verb: "GET",
    protocol: window.location.protocol,
    errorCode: null,
    userName: null,
    function: info,
    stacktrace: error.stack,
    data: JSON.stringify(store.state) 
  }

  axios.post(process.env.VUE_APP_TIM_URL + "/Admin/ErrorLog/CreateFromJson", payload)
    .then(function(response) {
      console.error(error, instance, info);
      console.warn("Error logged - " + response.data.id);
    })
    .catch(function(response) {
      console.error(error, instance, info)
      console.warn("Error log failed", response.data);
    })

}

// Configure analytics
let distributorGA4Enabled = false;
if (process.env.VUE_APP_TYPE === 'distributor' && process.env.VUE_APP_TRACKING_ENABLED === 'true') {
  distributorGA4Enabled = true;
}


app
.use(store)
.use(i18n)
.use(SweetModal)
.use(VueGtag, {
  enabled: distributorGA4Enabled,
  globalObjectName: "gtag_specialmachining", // avoid conflict with other instances of vue-gtag on the page
  config: {
    id: "G-F245JPC4T0", // GA ID for the widgets
    params: {
      send_page_view: false // Don't track pageviews automatically
    }
  }
})
.mount(`#thomsonspecialmachining-${process.env.VUE_APP_SCHEMA}`);
